import { Injectable } from "@angular/core";
import { filter, find } from 'lodash';

import { ApiService } from "../api/api.service";
import { TimeoutWrapperService } from "../timeout.wrapper/timeout.wrapper.service";
interface IResponse {
  data: Array<ILabel>;
}

export interface ILabel {
  id: string;
  group: string;
  label: string;
  msgText?: string;
  okText?: string;
  cancelText?: string;
  title:string;
  body:string;
  footer:string;
  reverseBtn:boolean;
}

@Injectable({
  providedIn: 'root'
})
export class LabelsService {
  private labels: Array<ILabel>;
  private retriesCount: number;
  constructor( private readonly apiService: ApiService,
                private readonly timeout: TimeoutWrapperService) {
    this.labels = [];
    this.retriesCount = 0;
  }


  initializeLabelData(fileName): Promise<any> {
    return this.apiService
      .get$<IResponse>("json/"+fileName, {}).toPromise()
      .then(
        (response: IResponse) => {
          if (response) {
            this.setLabels(response);
          }

        },
        error => {
          // for those unlikely cases, when getting the labels file for the first time fails.
          if (this.retriesCount < 2) {
            this.retriesCount++;
            this.timeout.add(() => {
              this.initializeLabelData(fileName);
            }, 1000);
          }
        }
      );
  }

  setLabels(result): void {
    this.labels = result;
  }

  getLabel(key: string): any {
    const result = find(this.labels, { id: key });
    if (result) {
      return result;
    }

    // in case label is not yet defined for specific key, the key itself is returned/giving a tip what must be added to labels
    return key;
  }

  // This is added for help icon information service.
  getHelpInfo(key: string): any {
    const result = find(this.labels, { id: key });
    const defaultResult = find(this.labels, { id: 'helpIconDefault' });
    if (result) {
      result.title = result.title ? result.title : defaultResult.title;
      result.body = result.body ? result.body : defaultResult.body;
      result.footer = result.footer ? result.footer : defaultResult.footer;   
      
      return result;
    }
    return defaultResult;
  }

  getLabelsByGroup(key: string): Array<ILabel> {
    const result = filter(this.labels, { group: key });
    if (result) {
      return result;
    }

    return null;
  }
}
